import axios2 from '../api/axios';
export const StockServices = {
    getstocktrackingdata,  
    addstock,
    editstock,
    getstock,
    createmultistockupdate,
    archivestock,
    updatedamagedstock,
    getdamagedstock,
    profitlossreport,
    getStockreports,
    getProductstockreports,
    getbulkproduct,
    Graphdataresult,
    getShopifyProducts,
    getShopifyorders,
    getWorhouseData,
    getShopifyLocationsviaAdminapi,     
    getShopifyProductsviaAdminapi,
    getanalytics,
    fetchForecast
}


function getstocktrackingdata(){
   return axios2.get(`/getstocktrackingdata`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getbulkproduct(page,pageSize){
    return axios2.get(`/getproducttrackingdata?page=${page}&limit=${pageSize}&orderby=${'least'}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}


function addstock(values){
   return axios2.post(`/addstock`,values,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })      
}

function editstock(values){
   return axios2.post(`/editstock`,values,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })      
}

function getstock(status,page,pageSize,{fromdate='',todate='',stocktype='component'} = {}){
   return axios2.get(`/getstock?status=${status}&page=${page}&limit=${pageSize}&fromdate=${fromdate}&todate=${todate}&stocktype=${stocktype}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })      
}

function getStockreports(status,page,pageSize,{fromdate='',todate='',stocktype='component'} = {}){
   return axios2.get(`/getStockreports?status=${status}&page=${page}&limit=${pageSize}&fromdate=${fromdate}&todate=${todate}&stocktype=${stocktype}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function getProductstockreports(status,page,pageSize,{fromdate='',todate='',stocktype='component'} = {}){
   return axios2.get(`/getProductstockreports?status=${status}&page=${page}&limit=${pageSize}&fromdate=${fromdate}&todate=${todate}&stocktype=${stocktype}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function createmultistockupdate(objdata){
    const formdata = new FormData();
    formdata.append('stockupdate',objdata); 
    return axios2.post(`/createexcelstockupdate`,formdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function archivestock(id,stocktype){
   return axios2.get(`/archivestock?id=${id}&stocktype=${stocktype}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
}

function updatedamagedstock(values){
   return axios2.post(`/updatedamagedstock`,values,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
      
}

function getdamagedstock(product_sku,purchase_order_id){
   return axios2.get(`/getdamagedstock?product_sku=${product_sku}&purchase_order_id=${purchase_order_id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function profitlossreport({year,month,status}){
   return axios2.get(`/profitlossreport?year=${year}&&month=${month}&&status=${status}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function Graphdataresult(){
   return axios2.get(`/Graphdataresult`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getShopifyProducts(){
   return axios2.get(`/shopify/getShopifyProducts`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getShopifyorders(){
   return axios2.get(`/shopify/orders`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   }) 
}

function getWorhouseData(){
     return axios2.get('/getWarehouseData',((response) => {
          return response;
     })).catch((error) =>{
          console.log(error);
     })
}

function getShopifyLocationsviaAdminapi(){
   return axios2.get(`/shopify/getShopifyLocationsviaAdminapi`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })     
} 

function getShopifyProductsviaAdminapi(){
   return axios2.get(`/shopify/getShopifyProductsviaAdminapi`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })
}

function getanalytics(){
     return axios2.get(`/getanalytics`,((response)=>{
          return response;
     })).catch((error)=>{
          console.log(error);
     })
}

function fetchForecast(filters){
     return axios2.get(`/forecast?days=${filters.days}`,((response)=>{
          return response;
     })).catch((error)=>{
          console.log(error);
     })
}


